import React, { useEffect, useRef } from "react";

export default function WaveformCanvas() {
    const canvasRef = useRef(null);

    const barCount = 50;
    const barWidth = 2;
    const gap = 2;

    const maxHeight = 20;
    const minHeight = 3;
    const speed = 400;

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        const width = canvas.width;
        const height = canvas.height;

        let barHeights = Array.from({ length: barCount }, () => 40);

        function updateHeights() {
            barHeights = barHeights.map(
                () => Math.random() * (maxHeight - minHeight) + minHeight
            );

            setTimeout(updateHeights, speed);
        }

        updateHeights();

        function draw() {
            ctx.clearRect(0, 0, width, height);

            const centerY = height/3.5;

            for (let i = 0; i < barCount; i++) {
                const barH = barHeights[i];
                const x = i * (barWidth + gap);

                ctx.fillStyle = "#000";

                ctx.fillRect(x, centerY - barH, barWidth, barH);

                ctx.fillRect(x, centerY, barWidth, barH);
            }

            requestAnimationFrame(draw);
        }

        draw();
    }, []);

    return (
        <canvas
            ref={canvasRef}
            width={200}
            height={60}
        />
    );
}
